import { chartKeys } from 'utils/constant';

const performance_overtime = {
  chartTitle: 'Trades made in profit/loss making patterns',
  chartKey: chartKeys.TRADES_IN_PATTERNS_TIMEVIEW,
}

export default performance_overtime;